import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { getId, usePermissions } from "../../user/User"
import SectorDetailView from "./SectorDetailView"

const SectorCreate = () => {
    const navigate = useNavigate()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.sector !== undefined && !permissions.sector) {
            toast.error("You don't have permission to create sectors!")
            navigate("/")
        }
    }, [permissions])
    
    const [name, setName] = useState("")

    return <SectorDetailView id={null}
        name={name} setName={setName}
    />
}
   
export default SectorCreate
